// src/parts/Jobs.js
import React, { useState, useEffect } from 'react';

// Sample central data for job listings
const jobData = [
  {
    id: 1,
    title: "Senior Web Designer",
    location: "Seattle, WA",
    applyLink: "/discuss-project",
  },
  {
    id: 2,
    title: "Front-End Engineer",
    location: "New York, NY",
    applyLink: "/discuss-project",
  },
  {
    id: 3,
    title: "UI/UX Designer",
    location: "Los Angeles, CA",
    applyLink: "/discuss-project",
  },
  {
    id: 4,
    title: "Web Developer",
    location: "Los Angeles, CA",
    applyLink: "/discuss-project",
  },
  {
    id: 5,
    title: "Web Designer & Developer",
    location: "Seattle, WA",
    applyLink: "/discuss-project",
  },
  {
    id: 6,
    title: "Visual Designer",
    location: "Los Angeles, CA",
    applyLink: "/discuss-project",
  },
];

const Jobs = () => {
  const [jobs, setJobs] = useState([]);

  useEffect(() => {
    // Simulating data fetching
    setJobs(jobData);
  }, []);

  return (
    <section className="jobs-section">
      <div className="jobs-container">
        <div className="jobs-row">
          <div className="jobs-col">
            <h2 className="current-openings">Current Openings</h2>
            <ul className="jobs-list">
              {jobs.map((job) => (
                <li key={job.id} className="job-item shadow-card">
                  <div className="job-content">
                    <h4 className="job-title">{job.title}</h4>
                    <h5 className="job-location">{job.location}</h5>
                  </div>
                  <a href={job.applyLink} className="job-apply-button">Apply</a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Jobs;
